import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class PreEngagementCheck extends ApplicationRecord {
  static jsonapiType = "pre_engagement_checks";

  @Attr() jobId: number | string;

  @Attr() recruiterId: number | string;

  @Attr() enoughCredits: boolean;

  @Attr() validSector: boolean;
}

export default PreEngagementCheck;
